import React, { useEffect, useState, useRef } from "react";

const PromtionPlanTable = () => {
    const [p_plans, setPPlan] = useState([]);
    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false); // 👈 add this
  
    useEffect(() => {
      if (didFetch.current) return; // 👈 prevent 2nd call
      didFetch.current = true;
  
      const fetchUsers = async () => {
        try {
          const response = await fetch("https://admin.swatee.in/api/p-bonus-percentage-chart");
          const data = await response.json();
          setPPlan(data);
          setLoading(false);
        } catch (error) {
          console.error("Error fetching users:", error);
          setLoading(false);
        }
      };
  
      fetchUsers();
    }, []);

    if (loading) return <p>Loading...</p>;

    return (
        <div>
            <table className="w-full border-2 text-center">
                <thead className="bg-primary border-b-2 border-secondary">
                    <tr>
                        <th className="border-2 p-3 text-lg font-semibold tracking-wide">
                            SNo.
                        </th>
                        <th className="border-2 p-3 text-lg font-semibold tracking-wide" colspan="2">
                            Range For Accumulate SP in DS Account in a month
                        </th>
                        <th className="border-2 p-3 text-lg font-semibold tracking-wide">
                            % P-Bonus of Earned Income in SP.
                        </th>
                    </tr>
                </thead>
                <tbody className="text-[#5C727D]">
                    {p_plans.map((plan, index) => (
                        <tr key={plan.id} className="hover:bg-gray-50">
                            <td className="border px-4 py-2">{index+1}</td>
                            <td className="border px-4 py-2">{plan.from_sp}</td>
                            <td className="border px-4 py-2">{plan.to_sp}</td>
                            <td className="border px-4 py-2">{plan.sp_bonus}%</td>
                        </tr>
                    ))} 
                </tbody>
            </table> 
        </div>
    );
};

export default PromtionPlanTable;
